module.exports = __webpack_public_path__ + "b12063537f77d43bedc3d2fac6244aba.jpg";